import ComplexInput from '@/mixins/ComplexInput';
import InputWithUnits from '@/components/InputWithUnits';

export default availableUnits => ({
  mixins: [ComplexInput],
  components: {
    InputWithUnits,
  },
  props: {
    placeholder: String,
  },
  data() {
    return { availableUnits };
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
  },
});



// WEBPACK FOOTER //
// ./mixins/InputWithUnits.js